const state = {
  job_dragging_enabled: true,
  round_to_copy: null,
  round_to_move: null,
  round_to_change: null,
};

const getters = {
  // eslint-disable-next-line no-unused-vars
  job_dragging_enabled: (state, getters) => {
    return state.job_dragging_enabled;
  },
};

const actions = {
  enable_job_dragging({ commit }) {
    commit("enable_job_dragging");
  },
  disable_job_dragging({ commit }) {
    commit("disable_job_dragging");
  },
  copy_round({ commit }, round) {
    commit("copy_round", round);
  },
  move_round({ commit }, round) {
    commit("move_round", round);
  },
  clear_move_round({ commit }) {
    commit("clear_move_round");
  },
  clear_copy_round({ commit }) {
    commit("clear_copy_round");
  },
  reset({ commit }) {
    commit("reset");
  },
  add_round_change({ commit }, round) {
    commit("add_round_change", round);
  },
  clear_add_round_change({ commit }) {
    commit("clear_add_round_change");
  },
};

const mutations = {
  enable_job_dragging(state) {
    state.job_dragging_enabled = true;
  },
  disable_job_dragging(state) {
    state.job_dragging_enabled = false;
  },
  copy_round(state, round) {
    state.round_to_copy = round;
  },
  move_round(state, round) {
    state.round_to_move = round;
  },
  clear_copy_round(state) {
    state.round_to_copy = null;
  },
  clear_move_round(state) {
    state.round_to_move = null;
  },
  add_round_change(state, round) {
    state.round_to_change = round;
  },
  clear_add_round_change(state) {
    state.round_to_change = null;
  },
  reset(state) {
    state.job_dragging_enabled = true;
    state.round_to_copy = null;
    state.round_to_move = null;
    state.round_to_change = null;
  },
};

export const status = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
